<template>
  <HeaderNavbar />

  <div class="home-container">
    <!-- Hero Section -->
    <section
      class="hero-section"
      :style="{ backgroundImage: `url(${require('@/assets/background.jpg')})` }"
    >
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <div class="hero-card">
          <h1>ŠK Batana</h1>
          <p>Za sve uzraste</p>
          <router-link to="/about" class="hero-btn">
            Otkrijte više
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </router-link>
        </div>
      </div>
    </section>

    <!-- Fair Play Section -->
    <section class="fair-play-section">
      <div class="fair-play-container">
        <div class="fair-play-logo">
          <img :src="require('@/assets/logo.png')" alt="ŠK Batana Logo" />
        </div>
        <div class="fair-play-content">
          <h2>Fair Play</h2>
          <p>
            Nastojimo osigurati sigurno okruženje u kojem će se moći družiti,
            igrati i napredovati. Predstavljamo mali klub velikih ambicija.
            Zadržavamo pravo objavljivanja sadržaja snimljenog u našem prostoru u
            svrhu promocije i širenja umijeća igranja šaha.
          </p>
        </div>
      </div>
    </section>

    <!-- Features Section -->
    <section class="features-section">
      <!-- Online Learning -->
      <div class="feature-card">
        <div class="feature-image">
          <img :src="require('@/assets/pehari-batana.jpg')" alt="Natjecanja" />
          <div class="feature-overlay">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
            </svg>
          </div>
        </div>
        <div class="feature-content">
          <h3>Online učenje</h3>
          <p>
            Odaberite učiti šah s nama. Od najmlađih do najvećih uzrasta. Primamo
            sve. Udaljenost nije problem jer je dio predavanja i većina materijala
            online. Isto tako možete rezervirati jednog od naših trenera za učenje
            online.
          </p>
          <router-link to="/ourteam" class="feature-btn">
            Više informacija
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </router-link>
        </div>
      </div>

      <!-- Chess School -->
      <div class="feature-card reverse">
        <div class="feature-content">
          <h3>Škola šaha</h3>
          <p>
            Namijenjena početnicima i onima koji to nisu. Učite šah uz naše
            članove tima.
          </p>
          <router-link to="/prijave" class="feature-btn">
            Prijave
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </router-link>
        </div>
        <div class="feature-image">
          <img :src="require('@/assets/prostor-batana.jpg')" alt="Prostor kluba" />
          <div class="feature-overlay">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
          </div>
        </div>
      </div>
    </section>

    <!-- Social Section -->
    <section class="social-section">
      <div class="social-content">
        <h2>Život i šah</h2>
        <p>
          Zaprati <span class="highlight">Šahovski klub Batanu</span><br />
          na Facebook-u i YouTube-u
        </p>
        <div class="social-icons">
          <a href="https://www.facebook.com/SahovskiKlubBatana/" class="social-link facebook" aria-label="Facebook">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </a>
          <a href="https://www.youtube.com/@sahovskiklubbatana5767" class="social-link youtube" aria-label="YouTube">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  </div>

  <FooterPage />
</template>

<script>
import HeaderNavbar from "@/components/HeaderNavbar.vue";
import FooterPage from "@/components/FooterPage.vue";

export default {
  name: "HomeView",
  components: {
    HeaderNavbar,
    FooterPage,
  },
};
</script>

<style scoped>
/* Container */
.home-container {
  min-height: 100vh;
}

/* Hero Section */
.hero-section {
  position: relative;
  height: 100vh;
  min-height: 700px;
  max-height: 900px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(26, 26, 46, 0.7) 0%,
    rgba(102, 126, 234, 0.3) 100%
  );
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  padding: 0 20px;
  animation: heroFadeIn 1.2s ease-out;
}

.hero-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 60px 80px;
  border-radius: 24px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.3);
  text-align: center;
  transition: all 0.4s ease;
}

.hero-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 40px 100px rgba(102, 126, 234, 0.4);
}

.hero-card h1 {
  font-size: clamp(3rem, 8vw, 5rem);
  font-weight: 900;
  color: #1a1a2e;
  margin-bottom: 15px;
  letter-spacing: -2px;
}

.hero-card p {
  font-size: clamp(1.5rem, 4vw, 2rem);
  color: #4a5568;
  margin-bottom: 35px;
  font-weight: 300;
}

.hero-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 18px 45px;
  border-radius: 50px;
  font-size: 1.125rem;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);
}

.hero-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(102, 126, 234, 0.5);
}

.hero-btn svg {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.hero-btn:hover svg {
  transform: translateX(5px);
}

/* Fair Play Section */
.fair-play-section {
  padding: 100px 20px;
  background: white;
}

.fair-play-container {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 40% 60%;
  gap: 60px;
  align-items: center;
}

.fair-play-logo {
  display: flex;
  justify-content: center;
  align-items: center;
}

.fair-play-logo img {
  width: 100%;
  max-width: 400px;
  height: auto;
  transition: transform 0.5s ease;
}

.fair-play-logo:hover img {
  transform: scale(1.05) rotate(2deg);
}

.fair-play-content h2 {
  font-size: clamp(2.5rem, 5vw, 3.5rem);
  font-weight: 800;
  color: #1a1a2e;
  margin-bottom: 25px;
}

.fair-play-content p {
  font-size: clamp(1.0625rem, 2vw, 1.25rem);
  line-height: 1.9;
  color: #4a5568;
  max-width: 90%;
}

/* Features Section */
.features-section {
  max-width: 1400px;
  margin: 100px auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 80px;
}

.feature-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  background: white;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);
  transition: all 0.4s ease;
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.15);
}

.feature-card.reverse {
  direction: rtl;
}

.feature-card.reverse .feature-content {
  direction: ltr;
}

.feature-image {
  position: relative;
  overflow: hidden;
  min-height: 450px;
}

.feature-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.feature-card:hover .feature-image img {
  transform: scale(1.1);
}

.feature-overlay {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.feature-overlay svg {
  width: 30px;
  height: 30px;
  color: #667eea;
}

.feature-content {
  padding: 60px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(135deg, #1a1a2e 0%, #2d3748 100%);
}

.feature-content h3 {
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 800;
  color: white;
  margin-bottom: 25px;
}

.feature-content p {
  font-size: clamp(1rem, 2vw, 1.125rem);
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 35px;
}

.feature-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 14px 35px;
  border-radius: 50px;
  font-size: 1.0625rem;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.3s ease;
  width: fit-content;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.feature-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 35px rgba(102, 126, 234, 0.5);
}

.feature-btn svg {
  width: 18px;
  height: 18px;
  transition: transform 0.3s ease;
}

.feature-btn:hover svg {
  transform: translateX(5px);
}

/* Social Section */
.social-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 100px 20px;
  position: relative;
  overflow: hidden;
}

.social-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect fill="rgba(255,255,255,0.03)" width="10" height="10" x="0" y="0"/><rect fill="rgba(255,255,255,0.03)" width="10" height="10" x="20" y="20"/><rect fill="rgba(255,255,255,0.03)" width="10" height="10" x="40" y="40"/><rect fill="rgba(255,255,255,0.03)" width="10" height="10" x="60" y="60"/><rect fill="rgba(255,255,255,0.03)" width="10" height="10" x="80" y="80"/></svg>');
  opacity: 0.3;
}

.social-content {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
}

.social-content h2 {
  font-size: clamp(2.5rem, 6vw, 4rem);
  font-weight: 900;
  color: white;
  margin-bottom: 25px;
  letter-spacing: -1px;
}

.social-content p {
  font-size: clamp(1.25rem, 3vw, 1.875rem);
  color: rgba(255, 255, 255, 0.95);
  line-height: 1.6;
  margin-bottom: 45px;
}

.highlight {
  color: #1a1a2e;
  font-weight: 800;
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 12px;
  border-radius: 6px;
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 25px;
}

.social-link {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 50%;
  transition: all 0.3s ease;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.social-link:hover {
  transform: translateY(-5px) scale(1.1);
  background: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.5);
}

.social-link svg {
  width: 32px;
  height: 32px;
  color: white;
}

.social-link.facebook:hover {
  background: #1877f2;
  border-color: #1877f2;
}

.social-link.youtube:hover {
  background: #ff0000;
  border-color: #ff0000;
}

/* Animations */
@keyframes heroFadeIn {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 1024px) {
  .fair-play-container {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }

  .fair-play-content p {
    max-width: 100%;
  }

  .feature-card,
  .feature-card.reverse {
    grid-template-columns: 1fr;
    direction: ltr;
  }

  .feature-image {
    min-height: 350px;
  }

  .feature-content {
    padding: 45px 35px;
  }
}

@media (max-width: 768px) {
  .hero-section {
    min-height: 600px;
  }

  .hero-card {
    padding: 40px 35px;
  }

  .fair-play-section {
    padding: 80px 20px;
  }

  .features-section {
    margin: 80px auto;
    gap: 60px;
  }

  .feature-image {
    min-height: 300px;
  }

  .social-section {
    padding: 80px 20px;
  }

  .social-icons {
    gap: 20px;
  }

  .social-link {
    width: 60px;
    height: 60px;
  }

  .social-link svg {
    width: 28px;
    height: 28px;
  }
}

@media (max-width: 480px) {
  .hero-section {
    min-height: 500px;
  }

  .hero-card {
    padding: 30px 25px;
  }

  .hero-btn {
    padding: 14px 30px;
    font-size: 1rem;
  }

  .fair-play-section {
    padding: 60px 15px;
  }

  .features-section {
    margin: 60px auto;
    gap: 40px;
  }

  .feature-content {
    padding: 35px 25px;
  }

  .social-section {
    padding: 60px 15px;
  }
}
</style>